export default {
  domains: {
    name: 'Domainname',
    status: 'Status',
    create: 'Erstellung',
    expire: 'Fälligkeit',
    delete: 'Löschung',
    suspended_at: 'Löschdatum',
    suspended_until: 'Wiederherstellung bis',
    user: 'Benutzer',
    updated_at: 'Letzte Aktualisierung',
    actions: 'Aktionen',
    username:'Benutzer'
  },
  domain_handles: {
    handle: 'Handle',
    type: 'Typ',
    organisation: 'Organisation',
    firstname: 'Vorname',
    lastname: 'Nachname',
    user: 'Benutzer',
    actions: 'Aktionen'
  },
  domain_nameserver: {
    servername: 'Servername',
    addresses: 'IP-Adressen',
    user: 'Benutzer',
    actions: 'Aktionen'
  },
  nameserver_zone: {
    name: 'Name',
    serial: 'Serial',
    updated_at: 'Letzte Aktualisierung',
    ttl: 'TTL',
    user: 'Benutzer',
    actions: 'Aktionen'
  },
  domain_prices:{
    country: 'Land',
    country_code: '',
    create: 'Erstellung',
    ownerchange: 'Besitzerwechsel',
    renew: 'Verlängerung',
    restore: 'Wiederherstellung',
    tld: 'Endung',
    transfer: 'Transfer',
    update: 'Update'
  },
  domain_price_discounts:{
    tld: 'Endung',
    end_date: 'Anfang',
    price: 'Preis',
    start_date: 'Ende',
    type: "Erstellen",
    years: 'Jahre'
  },

  vservers: {
    id: 'ID',
    title: 'Titel',
    hostname: 'Hostname',
    memory: 'Arbeitsspeicher',
    user: 'Benutzer',
    updated_at: 'Letzte Aktualisierung',
    actions: 'Aktionen',
  },
  vserver_backups: {
    id: 'ID',
    vserver_id:'Vserver ID',
    title: 'Titel',
    updated_at: 'Letzte Aktualisierung',
    actions: 'Aktionen',
    path:'Pfad',
    size:'Größe',
    created_at:'Erstellt'
  },
  vserver_networks: {
    id: 'ID',
    vserver_id:'Vserver ID',
    updated_at: 'Letzte Aktualisierung',
    created_at:'Erstellt',
    user:'Nutzer',
    mac_address: 'Mac Adresse',
    netname: 'Netz',

  },
  vserver_ipaddresses:{
    address: 'IP Adresse',
    id:'ID'
  },
  vserver_tasks:{
    start_time: 'Start',
    end_time: 'Ende',
    state:'Status',
    type:'Beschreibung'
  },
  vserver_scheduled:{
    last_execution: 'Letzte Ausführung',
    next_execution: 'Nächste Ausführung',
    created_at: 'Erstellt',
    type:'Typ'
  },
  users:{
    id:'ID',
    username:'Benutzer',
    actions:'Aktionen',
    email:'E-Mail',
    firstname:'Vorname',
    lastname:'Nachname',
    password:'Passwort',
    password_confirm:'Passwort wiederholen'
  },
  billing_positions:{
    id:'Id',
    user:'Benutzer',
    date:'Datum',
    title:'Titel',
    descr:'Beschreibung',
    price:'Preis',
    state:'Status',
    created_at:'Erstellt',
    amount:'Anzahl'

    //???

  },
  billing:{
    number:"Rechnungsnummer",
    user:"Benutzer",
    date:"Datum",
    due_date:"Fälligkeitsdatum",
    brutto:"Brutto",
    state:"Status",
    actions:"Aktionen"
  },
  transactions:{
    transaction:'Transaktion',
    user:'Benutzer',
    title:'Title',
    typ:'Typ',
    balance:'Kontostand',
    created_at:'Erstellt',
    amount:'Anzahl'
  }
}



// WEBPACK FOOTER //
// ./src/lang/de/table_heads.js